import { render, staticRenderFns } from "./PrivateMessageManagement.vue?vue&type=template&id=4baef81c&scoped=true"
import script from "./PrivateMessageManagement.vue?vue&type=script&lang=js"
export * from "./PrivateMessageManagement.vue?vue&type=script&lang=js"
import style0 from "./PrivateMessageManagement.vue?vue&type=style&index=0&id=4baef81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baef81c",
  null
  
)

export default component.exports